import { useEffect } from "react";
import '../assets/GoogleReviews.css';

const GoogleReviews = () => {

    useEffect(() => {
        const timer = setTimeout(() => {
            const elfsightBadge = document.querySelector(
                'a[href*="https://elfsight.com/google-reviews-widget/?utm_source=websites&utm_medium=clients&utm_content=google-reviews&utm_term=localhost&utm_campaign=free-widget"]'
            );
            if (elfsightBadge) {
                elfsightBadge.remove(); // or: elfsightBadge.style.display = "none";
            }
        }, 1500); // Adjust if widget loads slower

        return () => clearTimeout(timer); // cleanup
    }, []);


    useEffect(() => {
        // Suppress ResizeObserver error
        const originalConsoleError = console.error;
        console.error = (...args) => {
            if (
                typeof args[0] === "string" &&
                args[0].includes("ResizeObserver loop completed")
            ) {
                return;
            }
            originalConsoleError(...args);
        };

        // Load Elfsight script
        const script = document.createElement("script");
        script.src = "https://apps.elfsight.com/p/platform.js";
        script.async = true;
        document.body.appendChild(script);

        // Cleanup on unmount
        return () => {
            console.error = originalConsoleError;
        };
    }, []);

    return (
        <div className="google-reviews">
            <div className="elfsight-app-c8e6687b-f512-4886-8f2c-2145e95e076a"></div>

        </div>
    );
};

export default GoogleReviews;
